import { Stack } from "@mui/system";
import { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardContent,
  Container,
  Divider,
  Grid,
  SvgIcon,
  Typography,
} from "@mui/material";
import CustomAppBar from "../../../components/CustomAppBar";
import { useLocation, useNavigate } from "react-router";
import moment from "moment-timezone";
import { getDayReservationSuffix } from "../../../constants";
import CancelReservationModal from "../../../components/reservation/Modals/CancelReservationModal";
import CancelReservationSuccessModal from "../../../components/reservation/Modals/CancelReservationSuccessModal";
import MenuBar from "../../menuBar";
import { useResponsive } from "../../../hooks/useResponsive";

import { ReactComponent as LocationIcon } from "./../../../assets/svg/locationIcon.svg";
import { ReactComponent as ReservationDateIcon } from "./../../../assets/svg/res_dateIcon.svg";

import { ReactComponent as MonthlyRecurIcon } from "./../../../assets/svg/monthlyIcon.svg";
import { ReactComponent as AllocatedSpotsIcon } from "./../../../assets/svg/allocatedSpotsIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  cancelReservationRequest,
  getLocationSolrListApi,
} from "../../../redux/reservations/action";

const CancelReservationPage = () => {
  const { locationData } = useSelector((state) => state.reservationReducer);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const spotData = location?.state?.spotData;
  const lgUp = useResponsive("up", "lg");

  const [totalSpotCount, setSpotCount] = useState(0);

  const [truckSpots, setTruckSpot] = useState([]);
  const [trailerSpots, setTrailerSpot] = useState([]);
  const [trailerTruckSpots, setTrailerTruckSpot] = useState([]);

  const fromDate = moment(spotData?.fromDate);
  const toDate = moment(spotData?.toDate);

  // Get the day of the month
  const dayOfMonthfromDate = fromDate.date();
  const dayOfMonthtoDate = toDate.date();

  const formattedtofromDate = `${dayOfMonthfromDate}${getDayReservationSuffix(
    dayOfMonthfromDate,
  )} ${fromDate?.format("MMM YYYY")}`;

  const formattedtoDate = `${dayOfMonthtoDate}${getDayReservationSuffix(
    dayOfMonthfromDate,
  )} ${toDate?.format("MMM YYYY")}`;

  const reservationType =
    spotData?.reservationType === "MONTHLY" ? "Monthly " : "Daily ";

  const [isopenGate, setOpenGate] = useState(false);

  const [isCancelModal, setCancelModal] = useState({
    isVisible: false,
    data: {},
  });

  const [isCancelSuccessModal, setCancelSuccessModal] = useState({
    isVisible: false,
    data: {},
  });

  useEffect(() => {}, []);
  useEffect(() => {
    if (spotData?.spotAllocation[0].spots?.length) {
      const truckList = [];
      const trailerList = [];
      const trailerTruckList = [];
      spotData?.spotAllocation[0].spots?.forEach((element) => {
        setSpotCount((spots) => spots + element?.spotNums?.length);

        setSpotCount(element?.spotNums?.length);

        if (Array.isArray(element?.spotNums)) {
          // const
          element?.spotNums?.forEach((item) => {
            if (element?.spotType === "TRUCK") {
              truckList?.push(item?.spotNum);
            } else if (element?.spotType === "TRAILER") {
              trailerList?.push(item?.spotNum);
            } else if (element?.spotType === "TRUCK_AND_TRAILER") {
              trailerTruckList?.push(item?.spotNum);
            }
          });
        }
        setTruckSpot(truckList);
        setTrailerSpot(trailerList);
        setTrailerTruckSpot(trailerTruckList);
      });
    }
  }, [spotData]);

  useEffect(() => {
    if (spotData?.spotAllocation?.length > 0) {
      console.log(spotData);
      const params = {
        "q.op": "OR",
        start: "0",
        rows: "10000",
        wt: "json",
        cl: "OPS",
        fq: `location_id:${spotData?.spotAllocation[0].locationId}`,
      };

      dispatch(getLocationSolrListApi(params, (response) => {}));
    }
  }, [spotData]);

  useEffect(() => {
    // dispatch(getLocationList({}, (response) => {}));

    if (spotData?.spotAllocation?.length > 0) {
      if (spotData?.isReserve) {
        setTimeout(() => {
          navigate("/reservation", { state: { tabType: "current" } });
        }, 4000);
      }
    }
  }, [spotData]);

  return (
    <div
      style={{
        width: lgUp ? `calc(100% - ${240}px)` : "100%",
        marginLeft: lgUp ? "240px" : 0,
      }}
    >
      <CustomAppBar
        title={"Reservations"}
        showBackButton={true}
        onBackButtonClick={() => {
          navigate(location.state.from, { state: { tabType: "current" } });
        }}
      />
      <MenuBar />
      <Container
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        <Grid container direction={"column"} sx={{ mt: 2 }}>
          <Typography variant="h5" color={"primary.secondary"}>
            {/* Safe Truck Parking - Orlando */}
            {locationData?.length > 0 && locationData[0].location_display_name}
          </Typography>
          <Typography variant="body2" color={"primary.secondary"}>
            {/* 7501 Zell Dr, Orlando, FL, 67543 */}
            {locationData?.length > 0 &&
              locationData[0].location_address_line_1}
          </Typography>
          <Typography variant="body2" color={"primary.secondary"}>
            {`Reservation Id - ${spotData?.reservationId || "NA"}`}
          </Typography>
        </Grid>
        <Stack sx={{ mt: 2 }} spacing={2}>
          <Divider width={"100%"} />
        </Stack>
        <Stack sx={{ mt: 2 }} spacing={2}>
          <Grid container direction={"row"} sx={{ mt: 2 }}>
            <SvgIcon
              component={LocationIcon}
              inheritViewBox
              sx={{ width: "20px", height: "20px", mr: 1 }}
            />
            <Typography variant="body2" color={"primary.secondary"}>
              {/* 7501 Zell Dr, Orlando, FL, 67543 */}
              {`${
                locationData?.length > 0 &&
                locationData[0].location_address_line_1
              }, ${locationData?.length > 0 && locationData[0].location_city}`}
            </Typography>
          </Grid>
          <Grid container direction={"row"} sx={{ mt: 2 }}>
            {/* <CalendarMonth color="#1D5AB9" style={{ fill: "#1D5AB9" }} /> */}
            <SvgIcon
              component={ReservationDateIcon}
              inheritViewBox
              sx={{ width: "20px", height: "20px", mr: 1 }}
            />
            <Typography variant="body2" color={"primary.secondary"}>
              {`${formattedtofromDate} to ${formattedtoDate}`}
            </Typography>
          </Grid>
          <Grid container direction={"row"} sx={{ mt: 2 }}>
            {/* <AlarmOn color="#1D5AB9" style={{ fill: "#1D5AB9" }} /> */}
            <SvgIcon
              component={MonthlyRecurIcon}
              inheritViewBox
              sx={{ width: "20px", height: "20px", mr: 1 }}
            />
            <Typography variant="body2" color={"primary.secondary"}>
              {reservationType}
            </Typography>
          </Grid>
          <Grid container direction={"row"} sx={{ mt: 2 }}>
            <SvgIcon
              component={AllocatedSpotsIcon}
              inheritViewBox
              sx={{ width: "20px", height: "20px", mr: 1 }}
            />
            <Typography variant="body2" color={"primary.secondary"}>
              {/* 10 */}
              {`${totalSpotCount}  Spots booked`}
            </Typography>
          </Grid>
          <Grid container direction={"row"} sx={{ mt: 2 }}>
            <Typography variant="fontBoldSize16" color={"primary.secondary"}>
              Allotted Spots
            </Typography>
          </Grid>
          {truckSpots?.length > 0 && (
            <Grid container direction={"row"} sx={{ mt: 2 }}>
              <Typography variant="fontSize16" color={"#A19F9D"}>
                Truck -{" "}
                {truckSpots?.map((item) => {
                  return truckSpots?.length > 1 ? item + " ," : item;
                })}
              </Typography>
            </Grid>
          )}
          {trailerSpots?.length > 0 && (
            <Grid container direction={"row"} sx={{ mt: 2 }}>
              <Typography variant="fontSize16" color={"#A19F9D"}>
                Trailer -
                {trailerSpots?.map((item) => {
                  return trailerSpots?.length > 1 ? item + " ," : item;
                })}
              </Typography>
            </Grid>
          )}
          {trailerTruckSpots?.length > 0 && (
            <Grid container direction={"row"} sx={{ mt: 2 }}>
              <Typography variant="fontSize16" color={"#A19F9D"}>
                Trailer and Truck -
                {trailerTruckSpots?.map((item) => {
                  return item + " ,";
                })}
              </Typography>
            </Grid>
          )}
          <Grid container direction={"row"} sx={{ mt: 2 }}>
            <Typography variant="fontBoldSize16" color={"primary.secondary"}>
              Gate Access
            </Typography>
          </Grid>
          <Card>
            <CardContent>
              <Grid
                item
                container
                direction={"row"}
                spacing={0}
                sx={{ height: "20px" }}
                justifyContent={"space-between"}
              >
                <Grid item>
                  <Typography variant="gateTitle" color={"#656363"}>
                    Entrance
                  </Typography>
                </Grid>
                <Grid item>
                  <Button
                    type="submit"
                    variant="contained"
                    alignSelf={"center"}
                    style={{
                      alignSelf: "center",
                      width: 100,
                      height: 32,
                      alignItems: "center",
                      margin: "auto",
                      display: "flex",
                      borderRadius: "5px",
                    }}
                    className="update_button"
                    onClick={() => {}}
                  >
                    <Typography variant="buttonText" color="common.buttonText">
                      OPEN
                    </Typography>
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <Card>
            <CardContent>
              <Grid
                item
                container
                direction={"row"}
                spacing={0}
                sx={{ height: "20px" }}
                justifyContent={"space-between"}
              >
                <Grid item>
                  <Typography variant="gateTitle" color={"#656363"}>
                    Exit
                  </Typography>
                </Grid>
                <Grid item>
                  <Button
                    type="submit"
                    variant="contained"
                    alignSelf={"center"}
                    style={{
                      alignSelf: "center",
                      width: 100,
                      height: 32,
                      alignItems: "center",
                      margin: "auto",
                      display: "flex",
                      borderRadius: "5px",
                      backgroundColor: "#F3F2F1",
                    }}
                    className="update_button"
                    onClick={() => {
                      setOpenGate(!isopenGate);
                    }}
                  >
                    <Typography variant="buttonText" color="#A19F9D">
                      OPEN
                    </Typography>
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Stack>
        <Stack
          sx={{
            mt: 2,
            mb: 2,
            position: "absolute",
            bottom: 0,
            width: lgUp ? "75%" : "90%",
          }}
          spacing={2}
        ></Stack>
        {isCancelModal?.isVisible && (
          <CancelReservationModal
            isOpen={isCancelModal?.isVisible}
            onSubmit={() => {
              dispatch(
                cancelReservationRequest(
                  { reservationId: spotData?.reservationId },
                  {},
                  (response) => {
                    setCancelModal({ isVisible: false, data: {} });
                    if (Object.keys(response)?.length)
                      setCancelSuccessModal({ isVisible: true, data: {} });
                  },
                ),
              );
            }}
            onCancel={() => {
              setCancelModal({ isVisible: false, data: {} });
            }}
          />
        )}

        {isCancelSuccessModal?.isVisible && (
          <CancelReservationSuccessModal
            isOpen={isCancelSuccessModal?.isVisible}
            onSubmit={() => {
              setCancelSuccessModal({ isVisible: false, data: {} });
            }}
            onCancel={() => {
              setCancelSuccessModal({ isVisible: false, data: {} });
            }}
          />
        )}
      </Container>
    </div>
  );
};

export default CancelReservationPage;
